import store from '~store'

export const getYearOptions = function (range = 2) {
  let nd = new Date();
  let year = nd.getFullYear() - 1911;
  let month = nd.getMonth() + 1;
  if(month <= 8) year--;
  let semester = (month == 1 || month >= 9 ? 0 : 1);
  if(semester) semester = (month >= 7 ? 2 : 1);
  let semester_counr = year * 3 + semester - range;
  let year_options = [];
  for(range = range * 2 + 1; range--; semester_counr++) {
    year = Math.floor(semester_counr / 3);
    semester = ['1', '2', 'H'][semester_counr % 3];
    year_options.push(year + '-' + semester);
  }
  return year_options;
}

export const getDeptOfsOptions = async function () {
  await store.dispatch('pages/students/getDepartmentOfs');
  let departmentOfsGetter = store.getters['pages/students/departmentOfsGetter'];
  let dept_options = departmentOfsGetter.map(val => val.department_name);
  let dept_en_US_options = departmentOfsGetter.map(val => val.department_en_US);
  let dept_values = departmentOfsGetter.map(val => val.department_id);
  return { dept_options, dept_values, dept_en_US_options };
}

export const getDeptOptions = async function () {
  await store.dispatch('pages/students/getDepartments');
  let departmentsGetter = store.getters['pages/students/departmentsGetter'];
  let dept_options = departmentsGetter.map(val => val.department_name);
  let dept_en_US_options = departmentsGetter.map(val => val.department_en_US);
  let dept_values = departmentsGetter.map(val => val.department_id);
  return { dept_options, dept_values, dept_en_US_options };
}
